import { render, staticRenderFns } from "./EachChannelCanvas.vue?vue&type=template&id=1549316c"
import script from "./EachChannelCanvas.vue?vue&type=script&lang=js"
export * from "./EachChannelCanvas.vue?vue&type=script&lang=js"
import style0 from "./EachChannelCanvas.vue?vue&type=style&index=0&id=1549316c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports